import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { Stack } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import { useForm } from 'react-hook-form';
import { ButtonCustom, ButtonOutLine } from 'app/components/elements/ButtonCustom';
import { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { TriggerTypeFormSchema } from 'utils/validate';
import { TriggerType, TriggerTypeForm } from '../../../type';
import { TriggerSubTypeSection } from './TriggerSubTypeSection';

// Sub type management only makes sense while editing the trigger type actually
// named "Runtime" — matches the same literal string match used in ModalAddNewModel.
const RUNTIME_TRIGGER_TYPE = 'Runtime';

type ModalAddNewTriggerTypeProp = {
  isEdit?: boolean;
  isOpen: boolean;
  initData?: TriggerType;
  onCloseModal: () => void;
  onSubmit: (value: TriggerTypeForm) => void;
};

export const ModalAddNewTriggerType = ({
  isOpen,
  onCloseModal,
  onSubmit,
  isEdit,
  initData
}: ModalAddNewTriggerTypeProp) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = useForm<TriggerTypeForm>({
    resolver: yupResolver(TriggerTypeFormSchema),
    defaultValues: { name: '' }
  });

  useEffect(() => {
    if (!isOpen) {
      reset({ name: '' });
      return;
    }
    reset({ name: isEdit && initData ? initData.name : '' });
  }, [isOpen, isEdit, initData, reset]);

  return (
    <DialogConfirm
      maxWidth={480}
      textTitle={isEdit ? 'Edit Trigger Type' : 'Add New Trigger Type'}
      isOpen={isOpen}
      onClose={onCloseModal}>
      <Stack width={'100%'} gap={2}>
        <InputText
          colorTitle={'#226AAA'}
          inputError={errors.name?.message}
          placeholder={'Enter name'}
          title={'Name'}
          inputProps={{
            ...register('name'),
            disabled: isEdit
          }}
        />

        {isEdit && initData?.name === RUNTIME_TRIGGER_TYPE && <TriggerSubTypeSection />}

        <Stack
          width={'100%'}
          mt={'10px'}
          alignItems={'center'}
          justifyContent={'center'}
          flexDirection={'row'}
          gap={'20px'}>
          <ButtonOutLine
            label={'Cancel'}
            style={{ width: `calc((100% - 20px)/2)` }}
            onClick={onCloseModal}
            fullWidth
          />
          <ButtonCustom
            label={isEdit ? 'Save' : 'Add'}
            style={{ width: `calc((100% - 20px)/2)` }}
            onClick={handleSubmit(onSubmit)}
            disabled={isEdit}
            fullWidth
          />
        </Stack>
      </Stack>
    </DialogConfirm>
  );
};
